import { STATIC_PAGE_SLUGS } from '../../constants';

export const isStaticPage = (page) => STATIC_PAGE_SLUGS.indexOf(page.slug.toLowerCase()) !== -1;
